import React from "react";
import styled from "styled-components";

const StyledProjectCardLinks = styled.div.attrs({ "data-id": "cardlinks" })`
  display: flex;
  justify-content: center;
  transition: all 0.5s ease-in-out;

  & a {
    display: flex;
    font-weight: 700;
    align-items: center;
  }

  & a .projectCardLink_logo {
    width: 25px;
    margin-right: 7px;
  }
  & a .projectCardLink_sharelogo {
    width: 15px;
    margin-left: 2px;
  }

  & #livelink {
    margin-right: 3rem;
  }

  & a:hover {
    color: white;
  }

  & a:hover svg {
    fill: white;
  }

  @media only screen and (max-width: 750px) {
    justify-content: flex-start;
    padding: 0 1.5rem 0.2rem;

    & a {
      color: ${(props) => props.theme.accentColor};

      & svg {
        fill: ${(props) => props.theme.accentColor};
      }
    }

    & a .projectCardLink_logo {
      width: 17px;
      margin-right: 4px;
    }
    & a .projectCardLink_sharelogo {
      width: 10px;
      margin-left: 2px;
    }

    & #livelink {
      margin-right: 3rem;
    }
  }
`;
export const ProjectCardLinks = ({ liveLink, githubLink }) => {
  return (
    <StyledProjectCardLinks className="projectCard_buttons">
      <a href={liveLink} className="projectCardLink" id="livelink">
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="black"
          className="projectCardLink_logo"
          xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0)">
            <path d="M20 13.5626C16.4484 13.5626 13.5627 16.4483 13.5627 19.9999C13.5627 23.5515 16.4484 26.4372 20 26.4372C23.5516 26.4372 26.4373 23.5515 26.4373 19.9999C26.4373 16.4483 23.5516 13.5626 20 13.5626ZM19.5116 18.0909C18.7125 18.0909 18.0466 18.7569 18.0466 19.556H15.9156C15.96 17.5582 17.5583 15.96 19.5116 15.96V18.0909Z" />
            <path d="M39.5339 18.6681C37.3585 15.96 29.5893 7.12537 20 7.12537C10.4107 7.12537 2.64151 15.96 0.466149 18.6681C-0.155383 19.4228 -0.155383 20.5327 0.466149 21.3318C2.64151 24.0399 10.4107 32.8745 20 32.8745C29.5893 32.8745 37.3585 24.0399 39.5339 21.3318C40.1554 20.5771 40.1554 19.4672 39.5339 18.6681ZM20 29.3229C14.8502 29.3229 10.677 25.1498 10.677 20C10.677 14.8501 14.8502 10.677 20 10.677C25.1498 10.677 29.323 14.8501 29.323 20C29.323 25.1498 25.1498 29.3229 20 29.3229Z" />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="40" height="40" />
            </clipPath>
          </defs>
        </svg>
        <p> Live </p>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="black"
          className="projectCardLink_sharelogo"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M19.825 5.81596L14.4083 0.191032C14.2316 0.0077761 13.9608 -0.0497489 13.7251 0.0451597C13.4884 0.140984 13.3334 0.370168 13.3334 0.625139V3.33354H13.1251C8.64516 3.33354 5.00018 6.97852 5.00018 11.4584V12.7084C5.00018 12.9983 5.20434 13.24 5.48678 13.306C5.53271 13.3176 5.57848 13.3226 5.62426 13.3226C5.86016 13.3226 6.08599 13.1842 6.19509 12.9668C7.36679 10.6226 9.72257 9.16675 12.3434 9.16675H13.3334V11.875C13.3334 12.1301 13.4884 12.3593 13.7251 12.4542C13.9593 12.55 14.2316 12.4918 14.4083 12.3083L19.825 6.68342C20.0583 6.44096 20.0583 6.05934 19.825 5.81596Z" />
          <path d="M17.5 19.9999H2.50021C1.1219 19.9999 0.000244141 18.8784 0.000244141 17.4999V5.83347C0.000244141 4.45516 1.1219 3.3335 2.50021 3.3335H5.00018C5.46099 3.3335 5.83345 3.70596 5.83345 4.16677C5.83345 4.62758 5.46099 5.00004 5.00018 5.00004H2.50021C2.04016 5.00004 1.66679 5.37342 1.66679 5.83347V17.4999C1.66679 17.96 2.04016 18.3333 2.50021 18.3333H17.5C17.9599 18.3333 18.3333 17.96 18.3333 17.4999V10.8334C18.3333 10.3726 18.7057 9.99999 19.1666 9.99999C19.6275 9.99999 20 10.3726 20 10.8334V17.4999C20 18.8784 18.8783 19.9999 17.5 19.9999Z" />
        </svg>
      </a>
      <a href={githubLink} className="projectCardLink">
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="black"
          className="projectCardLink_logo"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M19.9975 0.416382C8.955 0.416382 0 9.40638 0 20.4964C0 29.3664 5.73 36.8914 13.68 39.5489C14.68 39.7339 15.045 39.1139 15.045 38.5814C15.045 38.1039 15.0275 36.8414 15.0175 35.1664C9.455 36.3789 8.28 32.4739 8.28 32.4739C7.3725 30.1539 6.06 29.5364 6.06 29.5364C4.2425 28.2914 6.195 28.3164 6.195 28.3164C8.2025 28.4589 9.2575 30.3864 9.2575 30.3864C11.0425 33.4539 13.94 32.5689 15.08 32.0539C15.26 30.7564 15.7775 29.8714 16.35 29.3689C11.91 28.8614 7.24 27.1389 7.24 19.4464C7.24 17.2539 8.02 15.4614 9.3 14.0564C9.0925 13.5489 8.4075 11.5064 9.495 8.74388C9.495 8.74388 11.175 8.20388 14.995 10.8014C16.59 10.3564 18.3 10.1339 20.0025 10.1264C21.7 10.1364 23.4125 10.3564 25.01 10.8039C28.8275 8.20638 30.505 8.74638 30.505 8.74638C31.595 11.5114 30.91 13.5514 30.705 14.0589C31.9875 15.4639 32.76 17.2564 32.76 19.4489C32.76 27.1614 28.085 28.8589 23.63 29.3564C24.3475 29.9764 24.9875 31.2014 24.9875 33.0739C24.9875 35.7589 24.9625 37.9239 24.9625 38.5814C24.9625 39.1189 25.3225 39.7439 26.3375 39.5464C34.275 36.8864 40 29.3639 40 20.4964C40 9.40638 31.045 0.416382 19.9975 0.416382Z" />
        </svg>
        <p> Github </p>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="black"
          className="projectCardLink_sharelogo"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M19.825 5.81596L14.4083 0.191032C14.2316 0.0077761 13.9608 -0.0497489 13.7251 0.0451597C13.4884 0.140984 13.3334 0.370168 13.3334 0.625139V3.33354H13.1251C8.64516 3.33354 5.00018 6.97852 5.00018 11.4584V12.7084C5.00018 12.9983 5.20434 13.24 5.48678 13.306C5.53271 13.3176 5.57848 13.3226 5.62426 13.3226C5.86016 13.3226 6.08599 13.1842 6.19509 12.9668C7.36679 10.6226 9.72257 9.16675 12.3434 9.16675H13.3334V11.875C13.3334 12.1301 13.4884 12.3593 13.7251 12.4542C13.9593 12.55 14.2316 12.4918 14.4083 12.3083L19.825 6.68342C20.0583 6.44096 20.0583 6.05934 19.825 5.81596Z" />
          <path d="M17.5 19.9999H2.50021C1.1219 19.9999 0.000244141 18.8784 0.000244141 17.4999V5.83347C0.000244141 4.45516 1.1219 3.3335 2.50021 3.3335H5.00018C5.46099 3.3335 5.83345 3.70596 5.83345 4.16677C5.83345 4.62758 5.46099 5.00004 5.00018 5.00004H2.50021C2.04016 5.00004 1.66679 5.37342 1.66679 5.83347V17.4999C1.66679 17.96 2.04016 18.3333 2.50021 18.3333H17.5C17.9599 18.3333 18.3333 17.96 18.3333 17.4999V10.8334C18.3333 10.3726 18.7057 9.99999 19.1666 9.99999C19.6275 9.99999 20 10.3726 20 10.8334V17.4999C20 18.8784 18.8783 19.9999 17.5 19.9999Z" />
        </svg>
      </a>
    </StyledProjectCardLinks>
  );
};
